import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import CurrencyConverter from "../../Currency/CurrencyConverter";
import { useTranslation } from "react-i18next";
import { ProgressBar } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { getLast24MonthsDates } from "../../utils/getLast24Months";
import { ApiHook } from "../../hooks/apiHook";

const DoughnutChart = ({
  pending,
  approved,
  paid,
  payoutPaid,
  currency,
  conversionFactor,
  userSelectedLanguage,
  leaderShipDetails,
  leaderRankActive,
  activePvStatus,
  leadersExcpetions,
}) => {
  const { t } = useTranslation();

  const filterData = getLast24MonthsDates();
  const [value, setValue] = useState(0);
  const [filterValue, setFilter] = useState(true);
  const [date, setDate] = useState(filterData[0]);
  const lbadvancmentData = ApiHook.CallLbAdvancement(
    filterValue,
    setFilter,
    date
  );


    const handleChange = (event, newValue) => {
    setDate(filterData[newValue]);
    setFilter(true);
    setValue(newValue);
  };


  return (
    <div>
      <div className="payout_overview_sec">
        {lbadvancmentData?.data?.lbAdvancement?.rankData?.length > 0 && (
          <>
            <h6>{t("lbCriteria")}</h6>
            <div className="payout_graph_sec">
              {leaderRankActive ? (
                <div className="top_right_personal_dtl_box_sec">
                  <div className="top_right_personal_dtl_box text-center">
                    <strong style={{ fontSize: "12px" }}>
                      <p style={{ color: "green", fontSize: "15px" }}>
                        {t("LBQqulified")}
                      </p>
                    </strong>
                  </div>
                </div>
              ) : (
                <>
                  <strong style={{ fontSize: "12px" }}>
                    <p style={{ color: "red", fontSize: "15px" }}>
                      {t("notqulified")}
                    </p>
                  </strong>
                </>
              )}
              <div className="progress_bar_starts">
                <p style={{ fontSize: "12px" }}>
                  {" "}
                  {t("4KCActive")}{" "}
                  {activePvStatus ? (
                    <strong>
                      <p style={{ color: "green", fontSize: "15px" }}>
                        {t("YES")}
                      </p>
                    </strong>
                  ) : (
                    <strong style={{ fontSize: "15px" }}>
                      <p style={{ color: "red", fontSize: "15px" }}>
                        {t("NO")}
                      </p>
                    </strong>
                  )}
                </p>
                     <p style={{ fontSize: "12px" }}>
                  {" "}
                  {t("Leader Level")}{" "}
                    <strong style={{ fontSize: "15px" }}>
                      <p style={{ color: "green", fontSize: "15px" }}>
                        {lbadvancmentData?.data?.lbAdvancement?.leadersExcpetions?.leaderLevel || 'N/A'}
                      </p>
                    </strong>
                </p>
                {lbadvancmentData?.data?.lbAdvancement?.rankData &&
                  lbadvancmentData?.data?.lbAdvancement?.rankData.map((leaderObj) => (
                    <div className="teammbrs_rank_progressbar">
                      <div className="teammbrs_rank_label">
                        <div className="teammbrs_rank_achievements">
                          <p>
                            {t(leaderObj?.name)} - (
                            {`${leaderObj?.achived || 0}/${
                              leaderObj?.goal || 0
                            }`}
                            )
                          </p>
                        </div>
                      </div>

                      <div className="teammbrs_rank_progress">
                        <ProgressBar
                          variant="success"
                          label={`${
                            parseFloat(leaderObj?.achived) >
                            parseFloat(leaderObj?.goal)
                              ? 100
                              : (
                                  (parseFloat(leaderObj?.achived) /
                                    parseFloat(leaderObj?.goal)) *
                                  100
                                ).toFixed(3)
                          } %`}
                          striped={true}
                          now={
                            parseFloat(leaderObj?.achived) >
                            parseFloat(leaderObj?.goal)
                              ? 100
                              : (parseFloat(leaderObj?.achived) /
                                  parseFloat(leaderObj?.goal)) *
                                100
                          }
                        />
                      </div>
                    </div>
                  ))}
              </div>
              <p style={{ fontSize: "12px" }}>
                {" "}
                {t("LinesofManagers")}{" "}
                <strong>
                  <p style={{ color: "green", fontSize: "15px" }}>
                    {lbadvancmentData?.data?.lbAdvancement?.leadersExcpetions?.currentDownlines}
                  </p>
                </strong>
              </p>

              <div />
            </div>
          </>
        )}
        {lbadvancmentData?.data?.lbAdvancement?.leadersExcpetions?.leaderKC.length>0 &&
        <Table style={{ fontSize: "12px" }} striped bordered hover>
          <thead>
            <tr>
              <th>Lines of Leader with 25 Total KC Last Month</th>
              <th>KC Needed</th>
            </tr>
          </thead>
          <tbody>
            {lbadvancmentData?.data?.lbAdvancement?.leadersExcpetions?.leaderKC.map((objValue) => (
              <tr>
                <td>{objValue.downlinecount}</td>
                <td>{objValue.pvdata}</td>
              </tr>
            ))}
          </tbody>
        </Table>
}


      <div className="cc_filter_tab">
        <Box
          sx={{ maxWidth: { xs: 150, sm: 350 }, bgcolor: "background.paper" }}
        >
          <Tabs
            value={value}
             onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            {filterData.map((monthObj) => (
              <Tab label={monthObj} />
            ))}
          </Tabs>
        </Box>
      </div>
      </div>
    </div>
  );
};

export default DoughnutChart;
